import { render, staticRenderFns } from "./ColunaEsquerda.vue?vue&type=template&id=31d384d6&scoped=true&"
import script from "./ColunaEsquerda.vue?vue&type=script&lang=js&"
export * from "./ColunaEsquerda.vue?vue&type=script&lang=js&"
import style0 from "./ColunaEsquerda.vue?vue&type=style&index=0&id=31d384d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d384d6",
  null
  
)

export default component.exports